import { PhoneCallNoteBuilder } from './phone-call-note/phone-call-note.builder';
import { PhoneCallEventBuilder } from './phone-call-event/phone-call-event.builder';
import { PhoneCallBuilder } from './../../../call-center/call/phone-call.builder';
import { TimelineItemType } from '../timeline';
var PhoneCallTimelineBuilder = /** @class */ (function () {
    function PhoneCallTimelineBuilder() {
        this.phoneCallTimeline = {
            id: '000-111111-000',
            creationDate: 0,
            phoneCall: new PhoneCallBuilder().build(),
            timelineItems: []
        };
    }
    PhoneCallTimelineBuilder.prototype.withPhoneCall = function (phoneCall) {
        this.phoneCallTimeline.phoneCall = phoneCall;
        return this;
    };
    PhoneCallTimelineBuilder.prototype.withTimelineItems = function (timelineItems) {
        this.phoneCallTimeline.timelineItems = timelineItems;
        return this;
    };
    PhoneCallTimelineBuilder.prototype.insertEvent = function (type, event) {
        var eventToInsert = (event || new PhoneCallEventBuilder().withEventType(type).build());
        eventToInsert.timelineItemType = TimelineItemType.EVENT;
        this.phoneCallTimeline.timelineItems.push(eventToInsert);
        return this;
    };
    PhoneCallTimelineBuilder.prototype.insertNote = function (content) {
        var note = new PhoneCallNoteBuilder().withContent(content).build();
        note.timelineItemType = TimelineItemType.NOTE;
        this.phoneCallTimeline.timelineItems.push(note);
        return this;
    };
    PhoneCallTimelineBuilder.prototype.build = function () {
        return this.phoneCallTimeline;
    };
    return PhoneCallTimelineBuilder;
}());
export { PhoneCallTimelineBuilder };
//# sourceMappingURL=phone-call-timeline.builder.js.map